// Morioka Portal v2 — ブラウザ側エントリポイント。

import { initComposers } from "./composer";
import { initPushButton, ensureCurrentAccountSubscribed } from "./push";
import { processFlashFromURL } from "./toast";
import { initTopNotice } from "./topnotice";
import { initPullRefresh } from "./pull_refresh";
import { initInteractions } from "./interactions";
import { initNewPostsPill } from "./new-posts-pill";
import { initOshaberiRoom } from "./oshaberi";
import { initPaidview } from "./paidview";
import { initAuthorRow } from "./author-row";

const VERSION = "v2.0.0-phase3";

function boot() {
  console.log(`[morioka-v2] booted (${VERSION})`);
  initComposers();
  initPushButton();
  initInteractions();
  // 上に出る知らせの層 (引っ張って更新・新着・遷移中の線) を先に置く
  initTopNotice();
  processFlashFromURL();
  initPullRefresh();
  initNewPostsPill();
  initOshaberiRoom();
  // 新守経済: 殻 (data-locked) の解錠とコンポーザの訊価メーター。
  initPaidview();
  // 作者行の省略 (X の作法 + Chromium の丸め癖の回避、author-row.ts)。
  initAuthorRow();
  // 許可済み端末では現在のアカウントの push 購読を毎回静かに再確認する
  // (多重アカウントで is_current_account が外れて OS 通知が消える問題の対策)。
  void ensureCurrentAccountSubscribed();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
